import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { getUserPermissions } from '@sde/widgets-core/src/redux/resources/user/helpers';
import { ApplicationLink } from 'src/common/ApplicationLink';
import {
  getStatus,
  getAppLink,
} from 'src/common/ApplicationLink/resources/inputFunctions';
import { styled } from '@uhg-abyss/web/tools/styled';

export const FlexWrapper = styled('div', {
  static: {
    width: '100%',
  },
  dynamic: ({ columns }) => {
    if (columns === 3) {
      return {
        flex: '0 0 33%',
      };
    }
    if (columns === 2) {
      return {
        flex: '0 0 50%',
      };
    }
    return {
      flex: '0 0 100%',
    };
  },
});

export const ColumnHandler = ({ contents, params, onClick }) => {
  const { user } = useUser.state();

  // Memoize permissions to avoid unnecessary re-renders
  const appDSPermissions = useMemo(() => {
    if (user && user.permissions) {
      return getUserPermissions(user);
    }
    return {};
  }, [user]);

  const queryParamData = useMemo(
    () => (user ? { uuid: user.uuid } : {}),
    [user]
  );

  const columns = useMemo(
    () => [
      contents.slice(0, Math.ceil(contents.length / 2)),
      contents.slice(Math.ceil(contents.length / 2)),
    ],
    [contents]
  );

  return (
    <React.Fragment>
      <For each="column" of={columns} index="id1">
        <FlexWrapper columns={2} key={id1}>
          <For each="content" of={column} index="idx">
            <ApplicationLink
              {...content}
              isSuperUser={user?.isSuperUser}
              isUhcInsightsUser={user?.isUhcInsightsUser}
              key={`${content.name || idx}_${idx}`}
              {...getAppLink(content)}
              appDescription={content.description}
              appLink={content.link}
              {...getStatus(
                content.status,
                content.permission,
                content.noPrivilegeHide,
                appDSPermissions
              )}
              onClick={onClick}
              queryParamData={queryParamData}
            />
          </For>
        </FlexWrapper>
      </For>
    </React.Fragment>
  );
};

ColumnHandler.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  params: PropTypes.shape({}),
  onClick: PropTypes.func,
  columnClass: PropTypes.string,
  titleClass: PropTypes.string,
};

ColumnHandler.defaultProps = {
  onClick: () => {},
  params: {},
  columnClass: null,
  titleClass: 'sectionTitle',
};
